
import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "@/hooks/use-toast";

export const CheckoutSuccess = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const emailSentRef = useRef(false);
  const successProcessedRef = useRef(false);
  const canceledProcessedRef = useRef(false);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const success = searchParams.get('success');
    const canceled = searchParams.get('canceled');

    // Only show toast messages once per page load
    if (success === 'true' && !successProcessedRef.current) {
      successProcessedRef.current = true;
      localStorage.setItem('subscription_activated', 'true');
      localStorage.setItem('subscription_activated_time', Date.now().toString());
      
      toast({
        title: "Payment Successful!",
        description: "Thank you! Your subscription is now active and you have unlimited transformations.",
        duration: 6000,
      });
    }
    
    if (canceled === 'true' && !canceledProcessedRef.current) {
      canceledProcessedRef.current = true;
      toast({
        title: "Checkout Canceled",
        description: "Your payment was not completed. You can try again anytime.",
        variant: "destructive",
        duration: 6000,
      });
      
      localStorage.removeItem('selected_plan');
      navigate('/', { replace: true });
    }
  }, [location, navigate]);

  return null;
};
